// extracted by mini-css-extract-plugin
export default {"invoice-note":"InvoiceNote_invoice-note__5U1jf","invoice-note__content":"InvoiceNote_invoice-note__content__OO7FC","content__timestamp":"InvoiceNote_content__timestamp__fMAss"};